import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";

export const settings = ({ personType } = {}) => async (dispatch) => {
    try {
        const suffix = personType ? `/${personType}` : "";
        const res = await api.get(`/boards/settings${suffix}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
};

export const list = ({ personUuid, personType, includeProfileTypes = false } = {}) => async (dispatch) => {
    try {
        const res = isGuid(personUuid)
            ? await api.get(`/boards/tasks/p/${personUuid}`, { params: { personType, includeProfileTypes } })
            : { data: { items: [], columns: [], success: false } };
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
};

export const risky = ({ mine = true, limit = 12 } = {}) => async (dispatch) => {
    try {
        const res = await api.get(`/boards/tasks/risky`, { params: { mine, limit } });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
};

export const get = ({ uuid } = {}) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/boards/tasks/i/${uuid}`) : { data: { success: false } };
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
};

export const save = ({ uuid, personUuid, personType, status, title, description, priority, assignedToUuid, startBy, finishBy, sortOrder, meta } = {}) => async (dispatch) => {
    try {
        const res = await api.post(`/boards/tasks`, { uuid, personUuid, personType, status, title, description, priority, assignedToUuid, startBy, finishBy, sortOrder, meta });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
};

export const move = ({ uuid, personType, status, sortOrder } = {}) => async (dispatch) => {
    try {
        const res = isGuid(uuid)
            ? await api.put(`/boards/tasks/i/${uuid}/move`, { personType, status, sortOrder })
            : { data: { success: false } };
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
};

export const destroy = ({ uuid } = {}) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.delete(`/boards/tasks/i/${uuid}`) : { data: { success: false } };
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
};
